import { PropsWithChildren } from 'react';
import { theme } from '@frontend/theme';
import { mergeClasses } from '@frontend/design-system';
import { COMPOSER_BREAKPOINTS } from '../constants';
import { useContentComposer } from '../content-composer-provider';

type Props = PropsWithChildren<{
  className?: string;
}>;

// TODO: Implement the old default footer:
// hideDefaultFooter ? null : <Footer />;
export const ContentComposerFooter = ({ children, className }: Props) => {
  const { activePanel } = useContentComposer();

  return (
    <footer
      className={mergeClasses('content-composer-footer', className)}
      css={[
        {
          alignItems: 'center',
          background: theme.colors.white,
          borderTop: `solid 1px ${theme.colors.neutral20}`,
          display: 'grid',
          gridArea: 'footer',
        },
        activePanel === 'settings' && {
          [`@media (max-width: ${COMPOSER_BREAKPOINTS.MOBILE}px)`]: {
            display: 'none',
          },
        },
      ]}
    >
      {children}
    </footer>
  );
};
